<template>
  <div>
    <div>
      <b-row>
        <b-col>
          <component-header
            title="Report"
            :hasSearch="false"
            :hasRadio="true"
            :disableKey="disableKey"
            @dateRangeEmit="dateRangeEmit"
            @radioChangeInputEmit="dateRangeInput"
            :radioOptions="dayRadioOption"
            :hasReload="false"
            :hasClear="false"
            :hasCreate="false"
          />
        </b-col>
      </b-row>
    </div>
    <b-card>
      <b-row>
        <b-col md="2">
          <b-card style="height: 205px">
            Totale Order
            <h4>
              <i class="fa fa-line-chart" aria-hidden="true"></i> 
            </h4>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-table striped hover :items="items">
        <template slot="Invoice" slot-scope="data">
          <b-button variant="primary" @click="download(data.item.resultsInvoiceUrl)"
            >Download <i class="fa fa-download" aria-hidden="true"></i>
          </b-button>
        </template> </b-table
    ></b-card>
  </div>
</template>
<script>
import ComponentHeader from "@/components/componentHeader";
import LineChart from "@/components/chart/LineChart.vue";
import PieChart from "@/components/chart/piechart.js";
export default {
  name: "Reports",
  components: {
    PieChart,
    ComponentHeader,
    LineChart,
  },
  data() {
    return {
      chartOptions: {
        hoverBorderWidth: 10,
      },
      disableKey: false,
      dateFilter: 1,
      dayRadioOption: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 days",
          value: 7,
        },
        {
          text: "30 days",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      items: [
        {
          Date: "06-01-2022",
          BillingNumber: "2222222",
          BilingName: "Benjamin Alex",
          amount: 5000,
          status: "paid",
          Invoice: "",
        },
        {
          Date: "06-01-2022",
          BillingNumber: "2222222",
          BilingName: "Benjamin Alex",
          amount: 5000,
          status: "paid",
          Invoice: "",
        },
        {
          Date: "06-01-2022",
          BillingNumber: "2222222",
          BilingName: "Benjamin Alex",
          amount: 5000,
          status: "paid",
          Invoice: "",
        },
        {
          Date: "06-01-2022",
          BillingNumber: "2222222",
          BilingName: "Benjamin Alex",
          amount: 5000,
          status: "paid",
          Invoice: "",
        },
        {
          Date: "06-01-2022",
          BillingNumber: "2222222",
          BilingName: "Benjamin Alex",
          amount: 5000,
          status: "paid",
          Invoice: "",
        },
        {
          Date: "06-01-2022",
          BillingNumber: "2222222",
          BilingName: "Benjamin Alex",
          amount: 5000,
          status: "paid",
          Invoice: "",
        },
      ],
      pieChartData: {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: [
          "Total Order Amount",
          "Total Sale",
          "New Customer",
          "New Orders",
          "Avg. Sale",
          "Gross Profit",
        ],
        datasets: [
          {
            label: "Data One",
            backgroundColor: [
              "#41B883",
              "#E46651",
              "#00D8FF",
              "#ffcc00",
              "#eb6623",
              "#ff0000",
            ],
            data: [8, 10, 5, 9, 10, 7],
          },
        ],
      },
    };
  },
  methods: {
    dateRangeEmit(e) {
      this.dateFilter = e;
    },
    dateRangeInput(e) {
      this.dateFilter = e;
    },
    download(URL) {
      window.open(URL, "_blank");
    },
  },
};
</script>
